export interface PoolDirectoryQuery {
  page: number;
  pageSize: number;
  sortBy?: string;
  sortOrder?: string;
  filterColumn?: string;
  filterType?: string;
  filterValue?: unknown;
}

export const buildPoolDirectoryPath = (query: PoolDirectoryQuery): string => {
  const searchParams = new URLSearchParams({
    page: String(query.page),
    pageSize: String(query.pageSize),
  });

  if (query.sortBy) searchParams.set("sortBy", query.sortBy);
  if (query.sortOrder) searchParams.set("sortOrder", query.sortOrder);
  if (query.filterColumn && query.filterType && query.filterValue !== undefined) {
    searchParams.set("filterColumn", query.filterColumn);
    searchParams.set("filterType", query.filterType);
    searchParams.set("filterValue", String(query.filterValue));
  }

  return `devicePools?${searchParams.toString()}`;
};
